export enum TaggingRuleActionType {
  ADD_TAG = 'add tag',
  SET_CATEGORY = 'set category',
  SET_SUB_CATEGORY = 'set subcategory',
  // SET_ACCOUNT = 'set account',
  SET_COUNTERPARTY = 'set counterparty',
  SET_SIGN = 'set sign',
}
